<template>
  <div class="section-header">
    <p v-if="subtitleKey" class="section-subtitle">{{ $t(subtitleKey) }}</p>
    <h2 v-if="titleKey" class="section-title">{{ $t(titleKey) }}</h2>
    <p v-if="descriptionKey" class="section-description">
      {{ $t(descriptionKey) }}
    </p>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  subtitleKey: {
    type: String,
    default: null
  },
  titleKey: {
    type: String,
    default: null
  },
  descriptionKey: {
    type: String,
    default: null
  }
})
</script>

<!-- No styles needed - all styles come from global CSS -->